export default "__VITE_ASSET__Daru_Cxy__"